import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Landing from '../pages/Landing'

// "/" is the sales page for visitors; someone who is already signed in goes to their dashboard.
export default function HomeRoute() {
  const { user, isLoading } = useAuth()

  // A stored token means the session check is in flight: show nothing rather than flash the
  // landing page at someone who is about to be redirected. With no token there is nothing to wait for.
  if (isLoading && localStorage.getItem('token')) {
    return <div className="min-h-screen bg-[var(--bg-primary)]" />
  }
  return user ? <Navigate to="/dashboard" replace /> : <Landing />
}
